<template>
  <div class="container">
    <BaseFrame
      :infos="infos"
      :idText = "idText"
    >
      <div slot="content">
        <lk-form label-position="right" :label-width="130">
          <div class="cardContainer">
            <lk-card title="基本信息">
              <lk-row>
                <lk-col span="7">
                  <lk-form-item label="账户名:">
                    <span>{{headOfficeForm.sysUser.phone}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset="1">
                  <lk-form-item label="姓名:">
                    <span>{{headOfficeForm.sysUser.name}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset="1">
                  <lk-form-item label="性别:" class="inline">
                    <span>{{gender[headOfficeForm.sysUser.gender]}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row>
                <lk-col span="7">
                  <lk-form-item label="邮箱:">
                    <span>{{headOfficeForm.sysUser.email}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset="1">
                  <lk-form-item label="身份证:">
                    <span>{{headOfficeForm.sysUser.idCard}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-card>
          </div>
          <div class="cardContainer">
            <lk-card title="角色信息">
              <lk-row >
                <lk-col span="23">
                  <lk-form-item label="总部角色:" class="formatCheckbox">
                    <span>{{headOfficeForm.roleStrList}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-card>
          </div>
          <div class="cardContainer">
            <lk-card title="负责门店">
              <lk-row >
                <lk-col span="23">
                  <lk-form-item label="门店名称:">
                    <span>{{headOfficeForm.authStoreIdList}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-card>
          </div>
        </lk-form>
      </div>
    </BaseFrame>
  </div>
</template>
<script>
import BaseFrame from '@/components/frame/BaseFrame.vue';
import system from '@/services/system';
import utils from '@/libs/utils';

export default {
  name: 'branchAccountInfo',
  components: {
    BaseFrame,
  },
  data() {
    return {
      idText: '',
      gender: ['', '男', '女'],
      infos: null,
      headOfficeForm: {
        sysUser: {
          id: '',
          phone: '',
          email: '',
        },
        roleIdList: [],
        storeIdList: [],
      },
    };
  },
  methods: {
    // TODO 操作日志
    getInfos(id) {
      system.getUserInfo({ id }).then((res) => {
        if (res.data.status === 200) {
          // 填充面包屑导航下的信息
          const temp = Object.assign({}, res.data.data);
          const modifiedRecord = {};
          this.idText = '账户ID';
          modifiedRecord.id = temp.sysUser.id;
          modifiedRecord.createUserName = temp.sysUser.createUserName;
          modifiedRecord.createTime = utils.formatTime(temp.sysUser.createTime);
          modifiedRecord.modifiedUserName = temp.sysUser.modifiedUserName;
          modifiedRecord.modifiedTime = utils.formatTime(temp.sysUser.modifiedTime);
          this.infos = modifiedRecord;

          // 回显信息
          this.headOfficeForm = res.data.data;
          // 处理总部角色 将id转为字符串
          const roleStrList = [];
          this.headOfficeForm.sysPositionList.forEach((item) => {
            const ids = item.roleIdList;
            const roleList = item.roleList;
            for (const el of roleList) {
              if (ids.includes(el.id)) {
                roleStrList.push(el.name);
              }
            }
            item.roleStrList = roleStrList.join(', ');
          });
          // const roleStrList = [];
          // for (const item of this.headOfficeForm.roleList) {
          //   if (this.headOfficeForm.roleIdList.includes(item.id)) {
          //     roleStrList.push(item.name);
          //   }
          // }

          // 处理负责门店名称
          const authStoreIdList = [];
          for (const item of this.headOfficeForm.authStoreList || []) {
            if (this.headOfficeForm.authStoreIdList.includes(item.id)) {
              authStoreIdList.push(item.name);
            }
          }
          // 绑定到vm列表
          this.headOfficeForm.roleStrList = roleStrList.join(', ');
          this.headOfficeForm.authStoreIdList = authStoreIdList.join(', ');
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.getInfos(this.$route.params.id);
  },
};
</script>
<style lang="less" scoped>
  .cardContainer {
    margin-bottom: 16px;
  }
</style>
